import { useState } from "react";
import { Instagram, X } from "lucide-react";

const FORM_BG = "https://storage.mlcdn.com/account_image/1835935/91vbEgJFs7X6GOlqzUgAcacgoetE7JbwhTzOy382.jpg";

const ValouseNewsletterSection = () => {
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("fields[email]", email);
      formData.append("ml-submit", "1");
      formData.append("anticsrf", "true");
      await fetch(
        "https://assets.mailerlite.com/jsonp/1835935/forms/180756649534817307/subscribe",
        { method: "POST", body: formData, mode: "no-cors" }
      );
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    }
    setLoading(false);
  };

  return (
    <section id="newsletter" className="py-16 sm:py-20 px-6 bg-[#8d7a6b]">
      <div className="max-w-2xl mx-auto text-center space-y-6">
        <div className="space-y-2">
          <p className="font-serif text-base sm:text-lg text-[#F3E5CF] italic leading-[2]">
            Si le lien doit rester,
          </p>
          <p className="font-serif text-base sm:text-lg text-[#F3E5CF] italic leading-[2]">
            il trouvera son chemin.
          </p>
        </div>

        <div className="pt-4">
          <button
            data-testid="newsletter-open-btn"
            onClick={() => { setShowModal(true); setSubmitted(false); setEmail(""); }}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#F3E5CF] text-[#3F2A24] text-xs sm:text-sm tracking-[0.18em] shadow-sm hover:bg-[#5C3D2E] hover:text-[#F3E5CF] transition-colors min-h-[44px] cursor-pointer"
          >
            Je reçois les lettres du Cocon
          </button>
        </div>

        <div className="pt-4">
          <a
            href="https://www.instagram.com/exquisite_impactful_retreats/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#F3E5CF] text-[#3F2A24] text-xs tracking-[0.18em] shadow-sm hover:bg-[#5C3D2E] hover:text-[#F3E5CF] transition-colors min-h-[44px]"
          >
            <Instagram className="w-4 h-4" />
            <span>Je prolonge le lien</span>
          </a>
        </div>
      </div>

      {/* Modal overlay */}
      {showModal && (
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
          style={{ backgroundColor: "rgba(141, 122, 107, 0.85)" }}
          onClick={(e) => { if (e.target === e.currentTarget) setShowModal(false); }}
        >
          <div className="relative w-full max-w-[400px] rounded overflow-hidden shadow-2xl">
            {/* Close button */}
            <button
              data-testid="newsletter-close-btn"
              onClick={() => setShowModal(false)}
              className="absolute top-3 right-3 z-10 w-8 h-8 rounded-full bg-black/20 hover:bg-black/40 flex items-center justify-center transition-colors"
              aria-label="Fermer"
            >
              <X className="w-4 h-4 text-[#F3E5CF]" />
            </button>

            {/* Form card with background image */}
            <div
              className="w-full"
              style={{
                backgroundImage: `url(${FORM_BG})`,
                backgroundSize: "cover",
                backgroundPosition: "center center",
                backgroundRepeat: "no-repeat",
              }}
            >
              {!submitted ? (
                <div className="px-5 pt-5 pb-5">
                  <h4
                    className="text-center mb-3"
                    style={{
                      color: "#ffd6a8",
                      fontFamily: "Tahoma, Geneva, sans-serif",
                      fontSize: "34px",
                      fontWeight: 400,
                    }}
                  >
                    Reste dans le Cercle
                  </h4>
                  <p className="text-[#fff0f0] text-xl mb-1">Des messages choisis.</p>
                  <p className="text-[#fff0f0] text-xl mb-1">Des annonces en priorité.</p>
                  <p className="text-[#fff0f0] text-xl mb-6">Un lien discret mais vivant</p>

                  <form onSubmit={handleSubmit}>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Email"
                      required
                      className="w-full px-3 py-2.5 rounded text-sm text-[#333] border border-[#ccc] mb-4 outline-none"
                      data-testid="newsletter-email-input"
                    />
                    <button
                      type="submit"
                      disabled={loading}
                      className="w-full py-2.5 rounded text-sm font-bold cursor-pointer transition-colors"
                      style={{
                        backgroundColor: "#ffd6a8",
                        color: "#3b3a3a",
                        border: "none",
                        fontFamily: "Tahoma, Geneva, sans-serif",
                      }}
                      data-testid="newsletter-submit-btn"
                    >
                      {loading ? "..." : "VOLONTIERS!"}
                    </button>
                  </form>
                </div>
              ) : (
                <div className="px-5 py-10 text-center">
                  <h4
                    style={{
                      color: "#ffd6a8",
                      fontFamily: "Tahoma, Geneva, sans-serif",
                      fontSize: "34px",
                      fontWeight: 400,
                      marginBottom: "16px",
                    }}
                  >
                    MERCI
                  </h4>
                  <p className="text-[#f0e4da] text-xl">Tu recevras des messages choisis,</p>
                  <p className="text-[#f0e4da] text-xl">déposés avec intention.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ValouseNewsletterSection;
